import { useLanguage } from "./LanguageContext";
import "./HeroSection.css";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section id="HeroSection" className="hero-section text-white py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
            <h1 className="display-4 fw-bold mb-4">{t("heroTitle")}</h1>
            <p className="lead mx-auto mb-4 hero-paragraph">
              {t("heroParagraph")}
            </p>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center">
            <div className="hero-image-wrapper">
              <img
                src="https://res.cloudinary.com/dtem45qog/image/upload/v1780578735/self2-3_sfcgc7.jpg"
                alt="Hero Visual"
                className="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
